var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zidingyi_kefu",style:(_vm.shu.yangshi)},[(_vm.shu.shu)?_c('img',{style:(_vm.yangshi),attrs:{"alt":"","src":_vm.shu.shu.tu}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }